import { SettingsRepository } from "../repositories/SettingsRepository";

export class GetVerificationCode {
	constructor(private repository: SettingsRepository) {}
	execute(): Promise<string> {
		return this.repository.getVerificationCode();
	}
}
